<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :disabled="disabled" @click="renderDocs" color="primary" class="mr-3">
        <v-icon>
          mdi-printer-outline
        </v-icon>
      </v-btn>
    </template>
    lade ein Archiv (.zip) aller<br>
    Schülerzeugnisse herunter.
  </v-tooltip>
      <!--
      <icon>mdi-file-word</icon>
      <icon>mdi-file-word-box</icon>
      <icon>mdi-file-word</icon>
      <icon>mdi-file-word-outline</icon>
      <icon>mdi-printer</icon>
      <icon>mdi-printer-outline</icon>
      <icon>mdi-fingerprint</icon>
      <icon>mdi-cloud-print</icon>
      -->
</template>

<script>
import Docxtemplater from 'docxtemplater'
import PizZip from 'pizzip'
import PizZipUtils from 'pizzip/utils/index.js'
import { saveAs } from 'file-saver'

export default {
  props: [
    'disabled',
    'reportObj',
    'studentsArr'
  ],
  methods: {
    transform (string) {
      let newString = ''
      let first = true
      for (const char of string) {
        if (char === '"' && first) {
          newString = `${newString}${String.fromCharCode(0x201e)}`
          first = false
        } else if (char === '"' && !first) {
          newString = `${newString}${String.fromCharCode(0x201c)}`
          first = true
        } else {
          newString = `${newString}${char}`
        }
      }
      return newString
    },
    getZielString (ziel) {
      const zielSubString = ziel > 9 ? 'Realschulabschlusses' : 'Hauptschulabschlusses'
      return this.reportObj.gymOrOs === 'os' && this.reportObj.klasse >= 7
        ? `nahm am Unterricht mit dem Ziel des ${zielSubString} teil.`
        : ''
    },
    getKlasseString () {
      let klasse = this.checkInput(this.reportObj.klasse)
      if (this.reportObj.klasseZusatz !== undefined) {
        klasse = `${klasse}${this.reportObj.klasseZusatz}`
      }
      return klasse
    },
    checkInput (value) {
      if (value === null) return 0
      // return (value === undefined || value === null) ? 'kA' : value
      return (value === undefined) ? 'kA' : value
    },
    checkKey (gradeObj) {
      if (gradeObj !== undefined) {
        if (
          this.reportObj.klasse === 10 &&
          this.reportObj.gymOrOs === 'os' && (
            gradeObj.name === 'Gemeinschaftskunde/Rechtserziehung' ||
            gradeObj.name === 'Geographie' ||
            gradeObj.name === 'Geschichte' ||
            gradeObj.name === 'Kunst' ||
            gradeObj.name === 'Musik'
          )
        ) return gradeObj.value !== null ? gradeObj.value : '-'
        else if (this.reportObj.gymOrOs === 'os' && gradeObj.name === 'Französisch') {
          return gradeObj.value !== null ? gradeObj.value : ''
        } else if (
          this.reportObj.klasse === 10 &&
          this.reportObj.gymOrOs === 'os' &&
          gradeObj.name === 'Wirtschaft-Technik-Haushalt/Soziales_9'
        ) {
          return gradeObj.value !== null ? gradeObj.value : '-'
        } else return gradeObj.value !== null ? gradeObj.value : 'tg'
        // return gradeObj.value !== null ? gradeObj.value : '!?'
      } else return '-'
    },
    checkProfilName (key) {
      return (key !== undefined) ? key.name : '-'
    },
    checkName (gradeObj) {
      if (gradeObj !== undefined) {
        return gradeObj.value !== null ? gradeObj.name : ''
      } else return ''
      // return (gradeObj !== undefined) ? gradeObj.name : '-'
    },
    checkSeit (key) {
      if (key !== undefined) {
        return key.value !== null ? key.note : ''
      } else return '(abschlussorientiert)'
      // return (key !== undefined) ? key.name : '-'
    },
    renderDocs () {
      const printSmall = this.reportObj.printSmall ? '_s' : ''
      const hjString = this.reportObj.hj ? '_hj' : ''
      const ejString = this.reportObj.ej ? '_ej' : ''
      // const zeString = this.reportObj.hj && this.reportObj.klasse === 10 && this.reportObj.gymOrOs === 'os' ? '_ze' : ''
      // PizZipUtils.getBinaryContent(`https://noten.dpfa.de/${this.reportObj.gymOrOs}${hjString}${ejString}${zeString}${printSmall}.docx`, this.printCallback)
      const is10OS = this.reportObj.klasse === 10 && this.reportObj.gymOrOs === 'os'
      const zeString = this.reportObj.hj && is10OS ? '_ze' : ''
      const azString = this.reportObj.ej && is10OS ? '_az' : ''
      PizZipUtils.getBinaryContent(`https://noten.dpfa.de/${this.reportObj.gymOrOs}${hjString}${ejString}${zeString}${azString}${printSmall}.docx`, this.printCallback)
    },
    printCallback (error, content) {
      if (error) {
        throw error
      }

      const zipAll = new PizZip()

      for (const student of this.studentsArr) {
        const zip = new PizZip(content)
        const doc = new Docxtemplater(zip, { paragraphLoop: true, linebreaks: true })

        doc.setData(this.getData(student))
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render()
        } catch (error) {
          // The error thrown here contains additional information when logged with JSON.stringify (it contains a properties object containing all suberrors).
          console.log(JSON.stringify({ error: error }, replaceErrors))

          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function (error) {
                return error.properties.explanation
              })
              .join('\n')
            console.log('errorMessages', errorMessages)
            // errorMessages is a humanly readable message looking like this :
            // 'The tag beginning with "foobar" is unopened'
          }
          throw error
        }
        const out = doc.getZip().generate({
          // type: 'blob',
          type: 'arraybuffer',
          compression: 'DEFLATE',
          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        })
        // https://stackoverflow.com/questions/64345139/how-do-i-create-a-zip-file-with-multiple-docx-files-generated-by-the-docxtempla
        // Output the document using Data-URI
        let filename
        if (this.reportObj.klasse !== undefined && student.name !== undefined) {
          const firstName = student.vorname.toLowerCase()
          const name = student.name.toLowerCase()
          filename = `${name}_${firstName}`
        } else {
          filename = 'output'
        }
        // zipAll.file(`${this.reportObj.klasse}${this.reportObj.gymOrOs}/${filename}.docx`, out)
        zipAll.file(`${filename}.docx`, out)
      }

      const outAll = zipAll.generate({ type: 'blob', compression: 'DEFLATE' })
      // saveAs(outAll, `${this.reportObj.klasse}${this.reportObj.gymOrOs}/${this.reportObj.klasse}${this.reportObj.gymOrOs}.zip`)
      saveAs(outAll, `${this.reportObj.klasse}${this.reportObj.gymOrOs}.zip`)
    },
    getData (student) {
      return {
        hj: this.reportObj.hj,
        ej: this.reportObj.ej,
        // schuleName1: `DPFA-Regenbogen-${this.reportObj.gymOrOs === 'os' ? 'Oberschule' : 'Gymnasium'} Zwickau`,
        // schuleName2: 'Staatlich anerkannte Ersatzschule',
        schuleName1: this.reportObj.schuleName.split(', ')[0],
        schuleName2: this.reportObj.schuleName.split(', ')[1],
        schuleStrasze: 'Salutstraße 4',
        schulePLZ: '08066',
        schuleOrt: 'Zwickau',
        kl: this.getKlasseString(),
        schuljahr: this.checkInput(this.reportObj.schuljahr),
        vorname: this.checkInput(student.vorname),
        name: this.checkInput(student.name),
        gebDatum: this.checkInput(student.gebDatum),
        gebOrt: this.checkInput(student.gebOrt),
        strasze: this.checkInput(student.strasze),
        plz: this.checkInput(student.plz),
        ort: this.checkInput(student.ort),
        ziel: this.getZielString(student.ziel),
        be: this.checkInput(student.betragen),
        mit: this.checkInput(student.mitarbeit),
        fl: this.checkInput(student.fleisz),
        ord: this.checkInput(student.ordnung),
        // kopfStern: student.stern === '1' ? '*' : '',
        einschaetzung: this.checkInput(student.einschaetzung),
        de: this.checkKey(student.fachnoten.de),
        ma: this.checkKey(student.fachnoten.ma),
        en: this.checkKey(student.fachnoten.en),
        bio: this.checkKey(student.fachnoten.bio),
        frName: this.checkKey(student.fachnoten.fr) !== '!?' ? this.checkName(student.fachnoten.fr) : '',
        fr: this.checkKey(student.fachnoten.fr) !== '!?' ? this.checkKey(student.fachnoten.fr) : '',
        frSeit: this.checkSeit(student.fachnoten.fr),
        ch: this.checkKey(student.fachnoten.ch),
        ku: this.checkKey(student.fachnoten.ku),
        ph: this.checkKey(student.fachnoten.ph),
        mu: student.fachnoten.mu !== undefined ? this.checkKey(student.fachnoten.mu) : 'tg',
        spo: this.checkKey(student.fachnoten.spo),
        ge: this.checkKey(student.fachnoten.ge),
        eth: this.checkKey(student.fachnoten.eth),
        grw: this.checkKey(student.fachnoten['g/r/w']),
        gk: this.checkKey(student.fachnoten.gk),
        tc: this.checkKey(student.fachnoten.tc),
        geo: this.checkKey(student.fachnoten.geo),
        inf: this.checkKey(student.fachnoten.inf),
        wth: this.checkKey(student.fachnoten.wth),
        wth2: this.checkKey(student.fachnoten.wth2),
        mkName: this.checkName(student.fachnoten.mk),
        mk: this.checkKey(student.fachnoten.mk),
        mk2Name: this.checkName(student.fachnoten.mk2),
        mk2: this.checkKey(student.fachnoten.mk2),
        gggName: this.checkName(student.fachnoten.ggg),
        ggg: this.checkKey(student.fachnoten.ggg),
        profilName: this.checkProfilName(student.fachnoten.nawi),
        profil: this.checkKey(student.fachnoten.nawi),
        fE: this.checkInput(student.fehlE),
        fUE: this.checkInput(student.fehlUE),
        versetzung: `${this.checkInput(student.vorname)} wird ${student.versetzung ? 'versetzt.' : 'nicht versetzt.'}`,
        bemerkungen: '',
        // gta: this.transform(student.gta),
        gta: student.gta,
        religionText: student.rel !== undefined ? student.rel.text : '',
        // relName: student.rel !== undefined ? student.rel.name : '',
        // rel: student.rel !== undefined ? student.rel.value : '',
        datum: this.checkInput(this.reportObj.datum)
        // fusznote: this.checkStern(student.stern)
      }
    }
  }
}

function replaceErrors (key, value) {
  if (value instanceof Error) {
    return Object.getOwnPropertyNames(value).reduce(function (
      error,
      key
    ) {
      error[key] = value[key]
      return error
    },
    {})
  }
  return value
}

</script>
